import { AxiosInstance } from 'axios';
import { plainToInstance } from 'class-transformer';
import { ReportDTO } from '../commons/dtos/report.dto';
import {
  IChatbotAPIResponse,
  IChatbotAPIResponsePagination
} from '../commons/interfaces/chatbotAPI.interface';
import { IReport, IReportFilters } from '../commons/interfaces/report.interface';
import Axios from './axios.service';

export default class ReportService {
  private request: AxiosInstance;

  constructor() {
    this.request = Axios.getInstance();
  }

  listReports = async (page: number, filters: string) => {
    const response = await this.request.get<IChatbotAPIResponsePagination<IReport[]>>(
      `/reports?${filters}`,
      {
        params: { pageSize: 10, page }
      }
    );

    const data = plainToInstance(ReportDTO, response.data.data);

    return { data, pagination: response.data.pagination };
  };

  exportReports = async () => {
    try {
      const response = await this.request.post(
        '/reports/export',
        {},
        {
          responseType: 'blob'
        }
      );

      const outpuFilename = 'Reportes.xlsx';
      const url = URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', outpuFilename);
      link.click();
      link.remove();

      return response;
    } catch (err: any) {
      throw new Error(err);
    }
  };

  listReportFilters = async (fields = '') => {
    const response = await this.request.get<IChatbotAPIResponse<IReportFilters>>(
      '/reports/filters',
      { params: { fields } }
    );

    return { data: response.data.data };
  };
}
